/* eslint-disable */
import React, { Component } from 'react';
import withRouter from '../../hooks/withRouter';
import API from '../../network';
import {
  CurrentInterviewsListRequestBody,
  CurrentInterviewsListValues,
  CurrentInterviewsProps,
  CurrentInterviewsState,
  CurrentInterviewsViewRendererProps,
} from './types';
import ViewRenderer from './views';
import { confirmWrapper } from 'src/components/Dialog';
import { CurrentInterviewsActions } from './components';
import { CurrentInterviewsFiltersSubmitHandler } from './components/CurrentInterviewsFilters';
import moment from 'moment';
import { PaginationState } from '@tanstack/react-table';

class CurrentInterviews extends Component<CurrentInterviewsProps, CurrentInterviewsState> {
  constructor(props: CurrentInterviewsProps) {
    super(props);

    this.state = {
      currentInterviewsFetching: false,
      currentInterviews: [],
      filters: {
        pagination: {
          pageIndex: 0,
          pageSize: 20,
          totalRecords: 0,
        },
      },
    };
  }

  componentDidMount(): void {
    this.getCurrentInterviewsList();
  }

  onApplyFilter = (data: CurrentInterviewsFiltersSubmitHandler) => {
    const { filters } = this.state;
    const { values } = data;

    const {
      dateRange, searchQuery, clients, interviewType,
      jobIds, recruiter, interviewer, status,
    } = values;

    const startDate = dateRange?.startDate ? moment(dateRange?.startDate).format('MM/DD/YYYY') : undefined;
    const endDate = dateRange?.endDate ? moment(dateRange?.endDate).format('MM/DD/YYYY') : undefined;
    const searchText = searchQuery;
    const clientId = clients ? [clients] : undefined;
    const interviewMode = interviewType
    const jobId = jobIds;
    const recruiterId = recruiter;
    const interviewerId = interviewer;
    const interviewStatus = status;

    this.setState(
      {
        currentInterviews: [],
        filters: {
          ...filters,
          interviews: {
            startDate,
            endDate,
            searchText,
            clientId,
            interviewMode,
            jobId,
            recruiterId,
            interviewerId,
            interviewStatus
          },
        },
      },
      () => {
        this.getCurrentInterviewsList();
      },
    );
  };

  onFiltersReset = () => {
    const { filters, currentInterviewsFetching } = this.state;
    if (currentInterviewsFetching) {
      return;
    }
    this.setState({
      filters: {
        ...filters,
        interviews: {},
      },
      currentInterviews: [],
    }, () => {
      this.getCurrentInterviewsList();
    });
  };

  getCurrentInterviewsList = async () => {
    this.setState({
      currentInterviewsFetching: true,
      currentInterviews: [],
    });
    const { filters } = this.state;
    const { pagination, interviews } = filters;

    const requestBody: CurrentInterviewsListRequestBody = {
      page: pagination.pageIndex,
      size: pagination.pageSize.toString(),
      ...interviews,
      jobOrderId: interviews?.jobId,
    };
    try {
      const currentInterviewsList = await API.getInstance().getCurrentInterviews(requestBody);
      this.setState({
        currentInterviews: currentInterviewsList?.currentInterviews,
        filters: {
          ...filters,
          pagination: {
            ...filters.pagination,
            totalRecords: currentInterviewsList?.totalElements,
          },
        },
      });
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      this.setState({
        currentInterviewsFetching: false,
      });
    }
  };

  onChangePagination = (data: PaginationState) => {
    const { filters } = this.state;
    this.setState(
      {
        filters: {
          ...filters,
          pagination: { ...filters.pagination, ...data },
        },
      },
      () => {
        this.getCurrentInterviewsList();
      },
    );
  };

  onUpdateInterviewStatus = async (request: any, close: (() => void) | undefined) => {
    try {
      // this.setState({
      //   loading: true,
      // });
      await API.getInstance().updateInterviewStatus(request);
      await confirmWrapper('Feedback submitted successfully.', {
        variant: 'success',
        autoClose: true,
        primaryBtnLabel: 'ok',
        hideSecondaryBtn: true,
      });
      if (close) close();
    } catch (e) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      // this.setState({
      //   loading: false,
      // });
    }
  };

  sendEmail = async (request: any, close: (() => void) | undefined) => {
    try {
      // this.setState({
      //   loading: true,
      // });
      await API.getInstance().sendEmail(request);
      await confirmWrapper('Email sent successfully', {
        hideSecondaryBtn: true,
        hidePrimaryBtn: true,
        variant: 'success',
        autoClose: true,
      });
      if (close) close();
    } catch (err) {
      await confirmWrapper('Something went wrong', {
        hideSecondaryBtn: true,
        variant: 'danger',
      });
    } finally {
      // this.setState({
      //   loading: false,
      // });
    }
  };

  onAction = async (data: CurrentInterviewsListValues) => {
    console.log(data);
    await confirmWrapper('', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'md',
      fullWidth: true,
      showCloseButton: true,
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent: (
        <CurrentInterviewsActions
          defaultValues={data}
          onSave={this.onUpdateInterviewStatus}
          sendEmail={this.sendEmail}
        />
      ),
    });
  };

  getProps = (): CurrentInterviewsViewRendererProps => {
    const {
      currentInterviews,
      currentInterviewsFetching,
      filters,
    } = this.state;

    return {
      currentInterviews,
      currentInterviewsFetching,
      filters,
      onAction: this.onAction,
      onApplyFilter: this.onApplyFilter,
      onFiltersReset: this.onFiltersReset,
      onChangePagination: this.onChangePagination,
      onUpdateInterviewStatus: this.onUpdateInterviewStatus,
      sendEmail: this.sendEmail,
    };
  };

  render() {
    const viewProps: CurrentInterviewsViewRendererProps = this.getProps();

    return (
      <ViewRenderer {...viewProps} />
    );
  }
}

export default withRouter(CurrentInterviews);
